export default __webpack_public_path__ + "static/media/Templates-color.56d7c0bb.svg";